"use client"
import TrailerPlayer from 'src/components/film/TrailerPlayer';
import { useTrailerContext } from 'src/components/film/TrailerWrapper';
import CloseSvg from 'src/components/svg/CloseSvg';
import PlaySvg from 'src/components/svg/PlaySvg';
import styles from './TrailerContent.module.css';
import classNames from 'classnames';

//#region [Props]
type TrailerContentProps = {
    trailerId?: number | string;
    streamingTrailer?: string | null;
    className?: string;
    showText?: boolean;
    isStreamingContext?: boolean;
};
//#endregion

//#region [Component]
export default function TrailerContent({ trailerId, streamingTrailer, className, showText = false, isStreamingContext }: TrailerContentProps) {
    const trailerContext = useTrailerContext();

    if (!trailerId && (!isStreamingContext || (isStreamingContext && !streamingTrailer))) return null;

    return <>
        <div className={classNames(styles.STrailerButton, className)}>
            <button className={styles.SButton} onClick={() => trailerContext.setIsPlaying(true)}>
                <PlaySvg className={styles.SPlaySvg} />
                {showText && <span className={styles.SIconText}>Trailer</span>}
            </button>
        </div>
        {trailerContext.isPlaying && <div className={styles.SPlayerContainer}>
            <button className={styles.SVideoCloseButton} onClick={() => trailerContext.setIsPlaying(false)}>
                <CloseSvg className={styles.SCloseSvg} />
            </button>
            <TrailerPlayer trailerId={trailerId} streamingTrailer={isStreamingContext ? streamingTrailer : undefined} />
        </div>}
    </>;
}
//#endregion

//#region [Styles]
// Converted to CSS Modules (TrailerContent.module.css)
//#endregion
